import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import { Grid, Stack, Toolbar, Typography } from "@mui/material";
import logo from "./../images/logo.png";
import "./../header/Header.css";
import { ComBtn } from "../commonFields/ComBtn";
import useMediaQuery from "@mui/material/useMediaQuery";
import { IconButton } from "@mui/material";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import Avatar from "@mui/material/Avatar";
import { useNavigate } from "react-router-dom"; // Import useNavigate from React Router


const StaticMainHeader = () => {
  const vMediaQuery = useMediaQuery("(max-width:600px)");
  const bMediaQuery = useMediaQuery("(max-width:360px)");
  const aMediaQuery = useMediaQuery("(min-width: 365px) and (max-width: 450px)");

  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate(); // Initialize the navigate function

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    navigate('/about'); // Navigate to the About page when the button is clicked
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to the top of the page
    setAnchorEl(null);
  };


  const handleAboutClick = () => {
    navigate('/about'); // Navigate to the About page when the button is clicked
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to the top of the page

  };

  const handleClick = () => {
    const footerElement = document.getElementById('contactInfo'); // Get the footer element by ID
    if (footerElement) {
      footerElement.scrollIntoView({ behavior: 'smooth' }); // Scroll to the footer element
    }
    setAnchorEl(null);
  };

  const heading = {
    fontWeight: 800,
    fontSize: aMediaQuery ? "23px" : vMediaQuery ? '18px' : "34px",
    marginLeft: aMediaQuery ? "8px" : vMediaQuery ? "4px" : "0px",
    padding: bMediaQuery ? '4px 10px' : '', fontFamily: "EB Garamond",
    backgroundImage: "linear-gradient(5deg, green, green)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    textAlign: "center",
  };

  const appbar = {
    top: 0, // Position at the top of the viewport
    zIndex: 1000, // Ensure it's above other content
    boxShadow: 1,
    background: "linear-gradient(2deg,#acd3fa, #e1f7e7)",
    padding: vMediaQuery ? "6px" : "",
    display: isScrolled ? "block" : "none",
  };

  const logoAction = () => {
    const logoElement = document.getElementById('logoElmt'); // Get the header element by ID
    if (logoElement) {
      logoElement.scrollIntoView({ behavior: 'smooth' }); // Scroll to the header element
    }
    setAnchorEl(null);
  };


  useEffect(() => {
    let scrollTimer = null;

    const handleScroll = () => {
      clearTimeout(scrollTimer); // Clear any existing timer

      scrollTimer = setTimeout(() => {
        if (window.scrollY > 0) {
          setIsScrolled(true);
        } else {
          setIsScrolled(false);
        }
      }, 500); // Set the delay in milliseconds
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(scrollTimer); // Clear the timer on unmount
    };
  }, []);

  return (
    <>
      <AppBar
        position="fixed" // Set position to fixed
        sx={appbar}
      >
        <Toolbar>
          <Grid container>
            <Grid item xs={2} md={3} lg={3}>
              <div className="logo-contanier">
                <img className="logonav" src={logo} alt="Logo" title="GDR Consultancy Services" onClick={logoAction} />
              </div>
            </Grid>
            <Grid
              item
              xs={8}
              md={6}
              lg={6}
              sx={{ padding: vMediaQuery ? "" : "20px" }}
            >
              <div style={{ display: 'flex !important', textAlign: "center !important", justifyContent: 'center !important' }}>
              <Typography variant="h4" sx={heading}>
                GDR Consultancy Services
              </Typography>
              </div>
            </Grid>
            <Grid item xs={2} md={3} lg={3}>
              <Stack
                direction={"row"}
                spacing={2}
                sx={{
                  justifyContent: vMediaQuery ? "center" : "flex-end",
                  padding: vMediaQuery ? "0px" : "30px 40px",
                  marginLeft:aMediaQuery ? '12px' : "10px",
                  marginTop: aMediaQuery || vMediaQuery ? '12px' : "0px",
                }}
              >
                {!vMediaQuery &&
                  <>
                    <ComBtn className={"btn"} onClick={handleAboutClick} text={"About Us"} />

                    <ComBtn className={"btn"} onClick={handleClick} text={"Contact Us"} />
                  </>
                }
                {vMediaQuery &&
                  <>
                    <Avatar variant="rounded" sx={{
                      width: 32, height: 32,
                      background: "green",
                      color: "#f0f4f5", textAlign: "center"
                    }}>
                      <IconButton sx={{
                        background: "green",
                        color: "#f0f4f5",
                        padding: "8px",
                      }}
                        aria-label="more"
                        id="long-button"
                        aria-controls={open ? 'long-menu' : undefined}
                        aria-expanded={open ? 'true' : undefined}
                        aria-haspopup="true"
                        onClick={handleMenu}
                      >
                        <MenuRoundedIcon />
                      </IconButton>
                    </Avatar>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button',
                      }}
                    >
                      <MenuItem onClick={handleClose}>About Us</MenuItem>
                      <MenuItem onClick={handleClick}>Contact Us</MenuItem>
                    </Menu>
                  </>
                }
              </Stack>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default StaticMainHeader;
